import React from "react";
import { useMeals } from "./MealsContext";

function DeleteMeal({ meal }) {
  const { setCart, cart } = useMeals();

  const handleDelete = (e) => {
    e.preventDefault();

    setCart((prevCart) => {
      const existingItemIndex = prevCart.findIndex(
        (cartItem) => cartItem.meal.id === meal.id
      );

      if (existingItemIndex >= 0) {
        return [
          ...prevCart.slice(0, existingItemIndex),
          ...prevCart.slice(existingItemIndex + 1),
        ];
      }
      return prevCart;
    });
  };

  const isMealInCart = cart.some((cartItem) => cartItem.meal.id === meal.id);

  return isMealInCart ? (
    <img
      src="/assets/img/trash-icon.svg"
      alt="Remove"
      width="20"
      height="20"
      className="ml-1 cursor-pointer"
      onClick={handleDelete}
    />
  ) : (
    <div className="w-5 h-5 ml-1 hidden md:block"></div>
  );
}

export default DeleteMeal;
